module.exports = __webpack_public_path__ + "img/03.73c4f93d.png";